/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-pnc-add-addition-input-button',
    templateUrl: './pnc-add-addition-input-button.component.html',
    styleUrls: ['./pnc-add-addition-input-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PncAddAdditionInputButtonComponent {
    @Output() addAdditionalInput: EventEmitter<void> = new EventEmitter<void>();
    @Input() disabled: boolean;
    @Input() tooltipMessage: string;
    @Input() tooltipIsDisabled = false;
    @Input() baseDataCy: string;
    @Input() label: string;

    get iconDataCy(): string {
        return `${this.baseDataCy}-icon`;
    }

    get buttonDataCy(): string {
        return `${this.baseDataCy}-button`;
    }

    get textDataCy(): string {
        return `${this.baseDataCy}-text`;
    }

    get disableTooltip(): boolean {
        return !this.disabled || this.tooltipIsDisabled;
    }

    addAdditionalInputClick(): void {
        this.addAdditionalInput.emit();
    }
}
